// extracted by mini-css-extract-plugin
export default {"landing-page":"LandingPage_landing-page__NiPek","section-line":"LandingPage_section-line__Wf9-Y"};